import { render, staticRenderFns } from "./script-manage.vue?vue&type=template&id=c8486d1e"
import script from "./script-manage.vue?vue&type=script&lang=js"
export * from "./script-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports